import { appConfig } from '../../../../../../../config/customization';
import Device from '../../../../../../../constants/deviceSizes';

const blueMargin = `6px solid ${appConfig.colors.primary}`;
const deleteIcon = 48;

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: `calc(50% - ${deleteIcon}px)`,
    marginTop: 10,
    paddingLeft: `${appConfig.userDataManagement.userConfigBlueMargin ? '10px' : '0px'}`,
    boxSizing: 'border-box',
    borderLeft: appConfig.userDataManagement.userConfigBlueMargin && blueMargin,
    [Device.mobile]: {
      width: `calc(100% - ${deleteIcon}px)`
    }
  },
  checkbox: {
    margin: '10px 10px 10px 0px'
  },
  phone: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  deleteButton: {
    color: appConfig.colors.secondaryButton
  }
};
